import { render, staticRenderFns } from "./RadarChart.vue?vue&type=template&id=40ae6d9a&scoped=true"
import script from "./RadarChart.vue?vue&type=script&lang=js"
export * from "./RadarChart.vue?vue&type=script&lang=js"
import style0 from "./RadarChart.vue?vue&type=style&index=0&id=40ae6d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ae6d9a",
  null
  
)

export default component.exports